import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

export const CustomButtonsForm = (props) => {

    const { name, action, fullWidth, size, style } = props;
    const styles = useStyles();

    return (
        <div
            style={{
                position: 'static',
                bottom: 0,
                background: 'transparent',
                width: '100%',
                zIndex: 1000000000,
                height: '20%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderRadius: 6,
                ...style
            }}
        >            
            <Button
                type="submit"
                variant="outlined"
                fullWidth={ fullWidth }
                size={ size }
                className={styles.successBtn}
                onClick={ action }
            >
                { name }
            </Button>
        </div>
    )
};

CustomButtonsForm.defaultProps = {
    name: '',
    action: () => false,
    fullWidth: false,
    size: 'small',
    style: {}
}

const useStyles = makeStyles({
    successBtn: {
        background: '#00365F !important',
        color: '#fff !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    }
});